import React from 'react';
import { SvgIcon } from '@mui/material';

function ExpandIcon({ rotate = 0 }) {
  return (
    <SvgIcon viewBox="0 0 24 24" sx={{ transform: `rotate(${rotate})` }}>
      <g id="eva:arrow-up-fill">
        <g id="evaArrowUpFill0">
          <g id="evaArrowUpFill1">
            <g id="evaArrowUpFill2">
              <path
                d={`M7.78997 7.99993H16.21C16.5424 7.99945 16.8681 8.09312 17.1495 8.27009C17.4309 8.44706 17.6564
                8.70011 17.8 8.99993C17.968 9.35567 18.0327 9.75146 17.9867 10.1422C17.9408 10.5329 17.786 10.9029
                17.54 11.2099L13.33 16.3099C13.1647 16.5006 12.9605 16.6534 12.731 16.7582C12.5015 16.863 12.2522
                16.9172 12 16.9172C11.7477 16.9172 11.4984 16.863 11.2689 16.7582C11.0394 16.6534 10.8352 16.5006
                10.67 16.3099L6.45996 11.2099C6.21396 10.9029 6.05915 10.5329 6.01318 10.1422C5.96721 9.75146 6.03193
                9.35567 6.19997 8.99993C6.34351 8.70011 6.56902 8.44706 6.85041 8.27009C7.1318 8.09312 7.45755 7.99945
                7.78997 7.99993Z`}
                fill="#009ACE"
              />
              <path
                d={`M7.78997 7.99993H16.21C16.5424 7.99945 16.8681 8.09312 17.1495 8.27009C17.4309 8.44706 17.6564
                8.70011 17.8 8.99993C17.968 9.35567 18.0327 9.75146 17.9867 10.1422C17.9408 10.5329 17.786 10.9029
                17.54 11.2099L13.33 16.3099C13.1647 16.5006 12.9605 16.6534 12.731 16.7582C12.5015 16.863 12.2522
                16.9172 12 16.9172C11.7477 16.9172 11.4984 16.863 11.2689 16.7582C11.0394 16.6534 10.8352 16.5006
                10.67 16.3099L6.45996 11.2099C6.21396 10.9029 6.05915 10.5329 6.01318 10.1422C5.96721 9.75146 6.03193
                9.35567 6.19997 8.99993C6.34351 8.70011 6.56902 8.44706 6.85041 8.27009C7.1318 8.09312 7.45755 7.99945
                7.78997 7.99993Z`}
                fill="url(#paint0_linear_5303_131908)"
              />
              <path
                d={`M7.78997 7.99993H16.21C16.5424 7.99945 16.8681 8.09312 17.1495 8.27009C17.4309 8.44706 17.6564
                8.70011 17.8 8.99993C17.968 9.35567 18.0327 9.75146 17.9867 10.1422C17.9408 10.5329 17.786 10.9029
                17.54 11.2099L13.33 16.3099C13.1647 16.5006 12.9605 16.6534 12.731 16.7582C12.5015 16.863 12.2522
                16.9172 12 16.9172C11.7477 16.9172 11.4984 16.863 11.2689 16.7582C11.0394 16.6534 10.8352 16.5006
                10.67 16.3099L6.45996 11.2099C6.21396 10.9029 6.05915 10.5329 6.01318 10.1422C5.96721 9.75146 6.03193
                9.35567 6.19997 8.99993C6.34351 8.70011 6.56902 8.44706 6.85041 8.27009C7.1318 8.09312 7.45755 7.99945
                7.78997 7.99993Z`}
                fill="black"
                fillOpacity="0.25"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5303_131908"
          x1="12"
          y1="16.9172"
          x2="12"
          y2="7.99993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#004876" />
          <stop offset="1" stopColor="#004976" stopOpacity="0" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}

export default ExpandIcon;
